import * as React from 'react';
import { ErrorWrapper } from '../ErrorWrapper';
import { topIcon } from '../../icons';

export const TopUnavailable = () => <ErrorWrapper icon={topIcon}>Размещение Топ объявления недоступно</ErrorWrapper>;
